export const DOCUMENT_TYPES = {
    DOC_TYPE_PENSION_A_DEILD: 'DOC_TYPE_PENSION_A_DEILD',
    DOC_TYPE_PENSION_B_DEILD: 'DOC_TYPE_PENSION_B_DEILD',
    DOC_TYPE_PENSION_SEREIGN: 'DOC_TYPE_PENSION_SEREIGN',
    DOC_TYPE_PENSION_RECIPIENT: 'DOC_TYPE_PENSION_RECIPIENT',
    DOC_TYPE_LOAN: 'DOC_TYPE_LOAN',
    DOC_TYPE_BANK_INFO_REQUEST: 'DOC_TYPE_BANK_INFO_REQUEST',
    DOC_TYPE_DOCTORS_CERTIFICATE: 'DOC_TYPE_DOCTORS_CERTIFICATE',
};
